var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBacklogsPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.648,
    height: 10.397,
    viewBox: "0 0 6.648 10.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-sort-1290015",
    transform: "translate(-271.953 -156.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8625",
    "data-name": "Path 8625",
    d: "M276.934,164.442l1.587-1.6c.043-.043.08-.029.08.034v1.429a.323.323,0,0,1-.083.2l-2.155,2.168a.42.42,0,0,1-.1.083h.017a.829.829,0,0,1-.1-.083l-2.155-2.168a.319.319,0,0,1-.083-.2v-1.429c0-.062.036-.078.08-.034l1.587,1.6c.043.043.08.028.08-.036v-3.39a.116.116,0,0,1,.116-.116h.932a.115.115,0,0,1,.116.116v3.39c0,.065.036.081.079.036Zm-3.314-5.769-1.587,1.6c-.043.043-.079.029-.079-.034v-1.429a.323.323,0,0,1,.083-.2l2.155-2.168a.422.422,0,0,1,.1-.083h-.017a.812.812,0,0,1,.1.083l2.155,2.168a.32.32,0,0,1,.083.2v1.429c0,.062-.036.078-.079.034l-1.587-1.6c-.043-.043-.08-.028-.08.036v3.39a.116.116,0,0,1-.116.116h-.932a.115.115,0,0,1-.116-.116v-3.39c0-.065-.036-.081-.08-.036Z",
    fill: "#4eb6ee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacklogsPriority);
export default __webpack_public_path__ + "static/media/backlogs-priority.3af3290ed287cf099665e96499ac86e0.svg";
export { ForwardRef as ReactComponent };